<template>
  <div class="payMentDetails">
    <el-dialog :title="$t('data.payin_details')" :visible.sync="dialogTableVisible" width="680px" class="diglog-card" @open="getDetailInfo">
      <div class="header-line" />
      <div class="total">
        <div class="total-item">
          <div class="total-title">{{ $t('data.paid') }}:</div>
          <div class="total-num">{{ $store.getters.currency }} {{ merchantInfo.transaction_amount | toDivideWithDot }}</div>
        </div>
        <div class="line" />
        <div class="total-item">
          <div class="total-title">{{ $t('data.fee') }}:</div>
          <div class="total-num">{{ $store.getters.currency }}  {{ merchantInfo.fee_split | toDivideWithDot }}</div>
        </div>
      </div>

      <div class="section-title">
        {{ $t('data.timeline') }}
      </div>
      <div class="line-bottom-1px" />
      <div class="item">
        <span class="item-left content-blue">{{ $t('data.payin_created') }}</span>
        <span class="content-blue">{{ $t('data.payin_completed') }}</span>
      </div>

      <div class="item">
        <span class="item-left" style="color: #4B5567">{{ merchantInfo.transaction_create_time }}</span>
        <span class="content-gray">{{ merchantInfo.transaction_return_time }}</span>
      </div>

      <div v-if="merchantInfo.transaction_status === TRANSACTION_STATUS['success']" class="item">
        <span class="item-left content-blue">{{ $t('data.estimated_settlement_time') }}</span>
        <span class="content-blue">{{ $t('data.actual_settlement_time') }}</span>
      </div>

      <div v-if="merchantInfo.transaction_status === TRANSACTION_STATUS['success']" class="item">
        <div class="item-left" style="color: #4B5567"><span>{{ merchantInfo.estimated_settlement_time || '/' }}</span></div>
        <div class="content-gray"><span>{{ merchantInfo.actual_settlement_time || '/' }}</span></div>
      </div>

      <div class="section-title">
        {{ $t('data.description') }}
      </div>
      <div class="line-bottom-1px" />

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.transaction_id') }}</span>
        <span class="content-gray">{{ merchantInfo.transaction_id || '' }}</span>
      </div>

      <div v-if="$store.getters.curCountry.country_code === 'TH' && merchantInfo.transaction_status === TRANSACTION_STATUS['void']" class="item">
        <span class="item-left content-blue">{{ $t('customerService.void_transaction_id') }}</span>
        <span class="content-gray">{{ merchantInfo.trans_void_resp && merchantInfo.trans_void_resp.void_no || '' }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.merchant_order_id') }}</span>
        <span class="content-gray">{{ merchantInfo.merchant_order_id || '' }}</span>
      </div>

      <div v-if="$store.getters.isPii" class="item">
        <span class="item-left content-blue">{{ $t('operation.business_name') }}</span>
        <span class="content-gray">{{ getRelatedInfo(merchantInfo, 'business') }}</span>
      </div>

      <div v-if="$store.getters.isPii" class="item">
        <span class="item-left content-blue">{{ $t('operation.franchisee_name') }}</span>
        <span class="content-gray">{{ getRelatedInfo(merchantInfo, 'franchisee') }}</span>
      </div>

      <div v-if="$store.getters.isMX && merchantInfo.channel_code === 'POS_STATIC_EDC'" class="item">
        <span class="item-left content-blue">{{ $t('data.pos_machine_sn') }}</span>
        <span class="content-gray">{{ merchantInfo.pay_data || '' }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('acceptPayments.static_qr_id') }}</span>
        <span class="content-gray">{{ merchantInfo.qr_stand_no || '' }}</span>
      </div>

      <div v-if="merchantInfo.settlement_status && merchantInfo.transaction_status === TRANSACTION_STATUS['success']" class="item">
        <span class="item-left content-blue">{{ $t('data.settlement_status') }}</span>
        <div class="content-gray"> <span> {{ getTransactionSettlementStatusMap( merchantInfo.settlement_status).label || '' }}</span></div>
      </div>

      <div v-if="$store.getters.curCountry.country_code === 'TH' && merchantInfo.transaction_status === TRANSACTION_STATUS['void']" class="item">
        <span class="item-left content-blue">{{ $t('customerService.void_complete_time') }}</span>
        <span class="content-gray">{{ merchantInfo.trans_void_resp && merchantInfo.trans_void_resp.void_complete_time || '' }}</span>
      </div>

      <div v-if="merchantInfo.channel_reference_no" class="item">
        <span class="item-left content-blue">{{ $t($store.getters.isMX ? 'customerService.ph_invoice_no' : 'customerService.invoice_no') }}</span>
        <span class="content-gray">{{ merchantInfo.channel_reference_no || '' }}</span>
      </div>

      <div v-if="[2].includes(merchantInfo.pay_product_type)" class="item">
        <span class="item-left content-blue">{{ $t('customerService.payment_code') }}</span>
        <span class="content-gray">{{ merchantInfo.pay_data || '' }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('merchant.payment_channel') }}</span>
        <span class="content-gray">{{ merchantInfo.channel_code || '' }}</span>
      </div>

      <div v-if="merchantInfo.fail_reason" class="item">
        <span class="item-left content-blue">{{ $t('data.fail_reason') }}</span>
        <span class="content-gray">{{ merchantInfo.fail_reason }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.pay_card_no') }}</span>
        <span class="content-gray">{{ merchantInfo.desensitization_card_no || '' }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.pay_card_scheme') }}</span>
        <span class="content-gray">{{ merchantInfo.card_scheme || '' }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.pay_card_issuer') }}</span>
        <span class="content-gray">{{ merchantInfo.card_issuer || '' }}</span>
      </div>

      <!-- <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.app_name') }}</span>
        <span class="content-gray">{{ merchantInfo.app_name }}</span>
      </div> -->

      <div class="item">
        <span class="item-left content-blue">{{ $t('merchantAccount.recipient_name') }}</span>
        <span class="content-gray">{{ merchantInfo.payer_name || '' |strAesDecryptAndAsterisk }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('merchantAccount.recipient_mobile') }}</span>
        <span class="content-gray">{{ merchantInfo.payer_mobile || '' |strAesDecryptAndAsterisk }}</span>
      </div>

      <div v-if="merchantInfo.transaction_status === 2" class="item">
        <span class="item-left content-blue">{{ $t('customerService.refund_type') }}</span>
        <span class="content-gray">{{ getRefundTypeMap(merchantInfo.refund_category|| '' ) }}</span>
      </div>

      <div v-if="merchantInfo.transaction_status === 2" class="item">
        <span class="item-left content-blue">{{ $t('customerService.cumulative_amount_refunded') }}
          <el-tooltip placement="top">
            <div slot="content">
              <span>{{ $t('tips.cumulative_amount_refunded_tip') }}</span>
            </div>
            <span> <svg-icon icon-class="icon-font-question" class="icon-question" /></span>
          </el-tooltip>
        </span>
        <span class="content-gray">{{ Math.abs(merchantInfo.total_refunded_amount) || '' | toDivideWithDot }}</span>
      </div>

      <div v-if="merchantInfo.transaction_status === 2" class="item">
        <span class="item-left content-blue">{{ $t('customerService.remaining_refundable_order_amount') }}
          <el-tooltip placement="top">
            <div slot="content" style="width: 300px">
              <span>{{ $t('tips.remaining_refundable_amount_tip') }}</span>
            </div>
            <span> <svg-icon icon-class="icon-font-question" class="icon-question" /></span>
          </el-tooltip>
        </span>
        <span class="content-gray">{{ Math.abs(merchantInfo.available_refund_amount) || '' | toDivideWithDot }}</span>
      </div>
      <template v-if="$store.getters.isID">
        <div v-if="compIsJTMerchant" class="item">
          <span class="item-left content-blue">{{ $t('customerService.jt_issuer_name') }}</span>
          <span class="content-gray">{{ merchantInfo.outer_pay_method }}</span>
        </div>

        <div v-if="comIsCargoMerchant" class="item">
          <span class="item-left content-blue">{{ $t('customerService.aggregate_cod_Amount') }}</span>
          <span class="content-gray">{{ merchantInfo.aggregate_cod_amount | toDivideWithDot }}</span>
        </div>

        <div v-if="comIsCargoMerchant" class="item">
          <span class="item-left content-blue">{{ $t('customerService.aggregate_cod_fee_amount') }}</span>
          <span class="content-gray">{{ merchantInfo.aggregate_cod_fee | toDivideWithDot }}</span>
        </div>

        <div v-if="comIsCargoMerchant" class="item">
          <span class="item-left content-blue">{{ $t('customerService.aggregate_frt_amount') }}</span>
          <span class="content-gray">{{ merchantInfo.aggregate_frt_amount | toDivideWithDot }}</span>
        </div>

        <div v-if="comIsCargoMerchant" class="item">
          <span class="item-left content-blue">{{ $t('customerService.aggregate_frt_fee_amount') }}</span>
          <span class="content-gray">{{ merchantInfo.aggregate_frt_fee | toDivideWithDot }}</span>
        </div>

        <div v-if="comIsCargoMerchant" class="item">
          <span class="item-left content-blue">{{ $t('customerService.transaction_fee_charge_mode') }}</span>
          <span class="content-gray">{{ getTransactionFeeChangeMode(merchantInfo.fee_split_type) }}</span>
        </div>
      </template>

      <div v-if="$store.getters.isID || $store.getters.isPii" class="item">
        <span class="item-left content-blue">{{ $t('data.split_amount') }}
          <el-tooltip placement="top">
            <div slot="content" style="width: 300px">
              <span>{{ $t('tips.split_amount_tips') }}</span>
            </div>
            <span> <svg-icon icon-class="icon-font-question" class="icon-question" /></span>
          </el-tooltip>
        </span>
        <span class="content-gray">{{ Math.abs(merchantInfo.already_split_amount) || '' | toDivideWithDot }}</span>
      </div>

      <el-tag :type="getPayTransactionStatusType(merchantInfo.transaction_status)" class="payin-status tag-custom"> {{ getPayTransactionStatusMap(merchantInfo.transaction_status) }}</el-tag>
    </el-dialog>
  </div>
</template>

<script>
import { fetchPayDetail } from '@/api/customer-service/customer-service'
import { payTransactionStatusVoidMap, payinPaymentMethodMap, refundStatusMap, transactionFeeChargeMode } from '@/utils/maps'
import { transactionSettlementStatusMap } from '@/maps/status.js'
export default {
  name: 'Payment_Details_Modal',
  components: {
  },
  props: {
    detailId: {
      type: [Number, String],
      default: '0'
    },
    authMerchantNo: {
      type: String,
      default: ''
    }
  },
  data() {
    this.TRANSACTION_STATUS = {
      success: 2,
      void: 4
    }
    return {
      dialogTableVisible: false, // 控制弹框显示隐藏
      listLoading: false,
      merchantInfo: { merchant: { merchant_basic_info: {}}, payment_fee: {}} // 用户基本信息
    }
  },
  computed: {
    getPayTransactionStatusMap() {
      return function(value) {
        return payTransactionStatusVoidMap(value).label
      }
    },
    getPayTransactionStatusType() {
      return function(value) {
        return payTransactionStatusVoidMap(value).type
      }
    },
    getPayinPaymentMethodMap() {
      return function(value) {
        return payinPaymentMethodMap(value).label
      }
    },
    getTransactionSettlementStatusMap() {
      return function(value) {
        return transactionSettlementStatusMap(value)
      }
    },
    getRefundTypeMap() {
      return function(value) {
        return refundStatusMap(value).label
      }
    },
    compIsJTMerchant() {
      return this.$store.state.user.isJtMerchant
    },
    comIsCargoMerchant() {
      return this.$store.state.user.isCargoMerchant
    },
    getTransactionFeeChangeMode() {
      return function(value) {
        return transactionFeeChargeMode(value).label
      }
    }
  },
  mounted() {
  },
  methods: {
    getRelatedInfo(transaction, relatedEntityType) {
      const relatedEntityNo = transaction[`${relatedEntityType}_no`]
      const relatedEntityName = transaction[`${relatedEntityType}_name`]
      return [relatedEntityNo, relatedEntityName].filter(Boolean).join(' / ') || '-'
    },
    getDetailInfo() {
      const params = { transaction_id: this.detailId }
      if (this.authMerchantNo) { // 服务商模式新增字段，用于查询服务商下面授权商户的交易详情
        params.auth_merchant_no = this.authMerchantNo
      }
      fetchPayDetail(params).then(res => {
        this.merchantInfo = res.data
        if (this.merchantInfo.total_refunded_amount === 0) {
          this.merchantInfo.refund_category = null
        }
      })
    },
    // 改变弹框状态
    changModalStatus(value) {
      this.dialogTableVisible = value
    },

    onClickCancal() {
      this.changModalStatus(false)
    }
  }
}
</script>
<style>
.payMentDetails .el-dialog__title {
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 16px;
  color: #000000;
}
.payMentDetails .header-line{
  margin: -26px 0 0;
  border-bottom: 1px solid #D3D7DF;
}
</style>

<style scoped lang="scss">
.total{
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 18px;
  min-width: 300px;

  .total-item{
    flex: 1;
    min-width: 0;
  }
  .line{
    display: inline-block;
    content:'';
    height: 52px;
    width: 1px;
    margin: 0 16px;
    background: #D3D7DF;
  }
  &-title{
    font-size: 14px;
    line-height: 17px;
    color: #606266;
  }
  &-num{
    margin-top: 12px;
    font-size: 22px;
    font-family: Source Han Sans SC;
    font-weight: 600;  font-family: 'Inter-SemiBold';
    line-height: 1.2;
    color: #3855F1;
    word-break: break-all;
  }
}
.item{
  display: flex;
  margin-top: 16px;
  .item-left{
    display: inline-block;
    width: 250px;
  }
}

.content-blue{
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 14px;
  line-height: 17px;
  background: linear-gradient(180deg, #488CE8 0%, #0058CF 100%);
background-clip: text;
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;;
}
.content-gray{
  flex: 1;
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 14px;
  line-height: 15px;
  color: #4B5567;
}

.payMentDetails{
  .payin-status{
    text-align: center;
    position: absolute;
    top: 17px;
    left: 160px;
  }
}

</style>
